/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_IntroInputs */

const tr_servis_s4_intro = /** @type {(inputs: Servis_S4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket aşağıdaki hizmet seviyelerini en iyi çaba temelinde hedefler:`)
};

const en_servis_s4_intro = /** @type {(inputs: Servis_S4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company targets the following service levels on a best effort basis:`)
};

const de_servis_s4_intro = /** @type {(inputs: Servis_S4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen strebt die folgenden Service Level auf Basis bestmöglicher Bemühungen an:`)
};

const ru_servis_s4_intro = /** @type {(inputs: Servis_S4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компания стремится обеспечить следующие уровни обслуживания на основе принципа максимальных усилий:`)
};

/**
* | output |
* | --- |
* | "The Company targets the following service levels on a best effort basis:" |
*
* @param {Servis_S4_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_intro = /** @type {((inputs?: Servis_S4_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_intro(inputs)
	if (locale === "de") return de_servis_s4_intro(inputs)
	if (locale === "ru") return ru_servis_s4_intro(inputs)
	return tr_servis_s4_intro(inputs)
});